import React from 'react';
import { config as FAConfig } from '@fortawesome/fontawesome-svg-core';
import { TypedMemo } from '../../common/types';
import { captureNativeAuthToken } from '../nativeAuthTokenHandoff';
import { captureLoginAsCode } from '../loginAsHandoff';
import { storedSessionIsLoginAs } from '../loginAs/loginAsClaim';
import { pauseAnalytics } from '../../analytics/sml/analyticsPause';

// Global styles
import '@fortawesome/fontawesome-svg-core/styles';

FAConfig.autoAddCss = false;

// Runs before React renders and before ReduxLoader reads `userToken`, so a
// native WebView handoff (`#authToken=<jwt>`) is already a sign-in on the very
// first render. Only a WebView that marks itself in the user agent is believed.
// See modules/app/nativeAuthTokenHandoff.ts.
captureNativeAuthToken();

// The admin "Log in as this user" handoff (`#loginAs=<code>`): the code leaves the URL here and
// stays in memory; `LoginAsGate` exchanges it before any screen reads the session. A native web
// view only strips it. See modules/app/loginAsHandoff.ts.
const loginAsCode = captureLoginAsCode();

// An admin visit is not activity of the user: no tracker starts for this page view. This runs
// before `UniversalAnalytics.setup()` in AppSML.
if (loginAsCode !== null || storedSessionIsLoginAs()) {
  pauseAnalytics();
}

const AppInitialEntryComponent: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <>{children}</>;
};
export const AppInitialEntry = TypedMemo(AppInitialEntryComponent);
